import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { compact } from 'lodash-es';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { Banner } from '../Banner';
import ApproveAllModal from './ApproveAllModal';
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ const listFormatter = new Intl.ListFormat();
export default function ApproveAllBar(param) {
    let { agreement, onClose, amendments, invoices, charges } = param;
    const { logBI } = useStoreActions();
    const { t: minisiteTexts } = useLocaleKeys('pages.agreementMinisite');
    const overlayContext = useOverlayContext();
    const approvalType = compact([
        charges > 0 && 'charges',
        invoices > 0 && 'invoices',
        amendments > 0 && 'amendments'
    ]);
    return /*#__PURE__*/ _jsx(Banner, {
        testId: "approve-all-banner",
        title: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "There are ",
                /*#__PURE__*/ _jsx("strong", {
                    children: listFormatter.format(approvalType)
                }),
                " awaiting your approval."
            ]
        }),
        actionButtonLabel: minisiteTexts.reviewAndApprove(),
        actionButtonIntent: Intent.ApproveAllBar,
        actionButtonOnClick: async (e)=>{
            e.preventDefault();
            logBI(10587);
            await overlayContext.showModal({
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(ApproveAllModal, {
                        agreement: agreement,
                        amendments: amendments,
                        invoices: invoices,
                        charges: charges,
                        dismissModal: (param)=>{
                            let { status } = param;
                            dismissModal();
                            onClose({
                                status
                            });
                        }
                    });
                }
            });
        },
        closeButtonOnClick: ()=>onClose({
                status: 'dismissed'
            })
    });
}
